import { render } from "./CarruselWeb.vue?vue&type=template&id=22271c1f"
import script from "./CarruselWeb.vue?vue&type=script&lang=js"
export * from "./CarruselWeb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__